export const BLURED_TABLE_DATA = [
    {
        member_id: 0,
        member_name: "Alice Example",
        member_role: "None",
        ability_scores: ["AMBER", "GREEN", "RED", "AMBER", "AMBER", "GREEN", "ABER", "RED"],
    },
    {
        member_id: 1,
        member_name: "Bob Testman",
        member_role: "None",
        ability_scores: ["AMBER", "AMBER", "RED", "AMBER", "GREEN", "RED", "AMBER", "GREEN"],
    },
    {
        member_id: 2,
        member_name: "Charlie Demo",
        member_role: "None",
        ability_scores: ["GREEN", "AMBER", "AMBER", "GREEN", "GREEN", "AMBER", "RE", "AMBER"],
    },
    {
        member_id: 3,
        member_name: "Diana Placeholder",
        member_role: "None",
        ability_scores: ["AMBER", "GREEN", "AMBER", "RED", "RED", "GREEN", "AMBER", "AMBER"],
    },
    {
        member_id: 4,
        member_name: "Grace Dummy",
        member_role: "None",
        ability_scores: ["RED", "GREEN", "AMBER", "RED", "AMBER", "GREEN", "AMBER", "GREEN"],
    },
    {
        member_id: 5,
        member_name: "Sybil Template",
        member_role: "None",
        ability_scores: ["AMBER", "GREEN", "RED", "AMBER", "GREEN", "AMBER", "GREEN", "RED"],
    },
    {
        member_id: 6,
        member_name: "Walter Testcase",
        member_role: "None",
        ability_scores: ["AMBER", "GREEN", "AMBER", "RED", "RED", "GREEN", "AMBER", "AMBER"],
    },
];
